export const loadingMap = [100, 70, 80, 100, 50, 80];
